var map = {
	"./account-circle.svg": 359,
	"./arrow-down-light.svg": 394,
	"./arrow-down.svg": 769,
	"./arrow-right-light.svg": 458,
	"./logo-old.svg": 716,
	"./logo.svg": 36,
	"./magnifying-glass-light.svg": 658,
	"./medical-records.svg": 887,
	"./pill.svg": 400,
	"./prescriptions.svg": 288,
	"./questionmark-circle.svg": 387,
	"./science.svg": 685,
	"./shield-lock.svg": 870,
	"./stethoscope.svg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;